import AlertDialog from "./AlertDialog";
import { withRouter } from "react-router-dom";

export default withRouter(AlertDialog);
